import { useEffect } from 'react';
import { useIsMobile } from 'hooks/useIsMobile';
import { useHistory } from 'react-router-dom';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general';
import { useVerificarCredito } from 'hooks/useVerificacionCredito';
import { encodeStorage } from 'functions/storageBase64';
import { useMooksVerificaCredito } from 'pages/Credito/1-Consulta/ModulosConsulta/mocks';

export function useHomePage() {

    const { isMobile } = useIsMobile();
    const history = useHistory();

    // Mocks
    // const { session_token, cardending, sears_numero_internet, estadoCredito, creditoDisponible, montoCredito, loading, aceptarCredito, setErrorCode, errorCode, setShowModalErr, sectionActive, showModalErr, messageResponse, associatedCards, cardsService } = useMooksVerificaCredito()

    // Productivos
    const { session_token, cardending, sears_numero_internet, estadoCredito, creditoDisponible, montoCredito, loading, aceptarCredito, setErrorCode, errorCode, setShowModalErr, sectionActive, showModalErr, messageResponse, associatedCards, cardsService } = useVerificarCredito()


    // verifica respuesta del servicio para redireccionar
    useEffect(() => {
        if (estadoCredito) {
            if (Number(estadoCredito) === 200) {
                console.log("entro a 200 , ", estadoCredito)
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
                // encodeStorage("flagAceptoCredito", 200);

            } else if (Number(estadoCredito) === 404) {
                console.log("entro a 404 , ", estadoCredito)
                if(Number(associatedCards?.tipo) !== 1){
                    history.replace(`${BASE_PATH}${SUB_DIRECTORY}home/consultar-saldo`);
                }
                else{
                    // encodeStorage("flagAceptoCredito", 404);
                    if(window.location.pathname != '/credito-claroshop/home'){
                        // history.replace(`${BASE_PATH}${SUB_DIRECTORY}home`);
                    }
                }
            }
            else if (Number(estadoCredito) === 409) {
                console.log("entro a 409 , ", estadoCredito)
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/autorizar`);
                
            }
            else if (Number(estadoCredito) === 412) {
                console.log("entro a 412 , ", estadoCredito)
                history.replace(`${BASE_PATH}${SUB_DIRECTORY}solicitud-credito-claroshop/autorizar`);
                
            }
            else if (Number(estadoCredito) >= 500) {
                setErrorCode(estadoCredito);
            }
        }


    }, [estadoCredito])


    useEffect(() => {
        if (!session_token && !cardending && !sears_numero_internet) {
            window.location.href = `${BASE_PATH}login?redirect=${window.location.href}`
        }
    }, [session_token])


    return {
        aceptarCredito,
        setShowModalErr,
        errorCode,
        loading,
        isMobile,
        montoCredito, 
        cardending,
        sectionActive,
        showModalErr,
        messageResponse
    }
}